<template>
  <div
    class="progress-circle __container"
    :style="{
      width: `${outerSquare}px`,
      height: `${outerSquare}px`,
      boxShadow: boxShadow,
    }"
  >
    <div
      class="progress-circle __inner-shadow"
      :style="{
        height: `${innerSquare}px`,
        width: `${innerSquare}px`,
        marginTop: `-${(innerSquare)/2}px`,
        marginLeft: `-${(innerSquare)/2}px`,
        boxShadow: innerBoxShadow,
      }"
    />
    <svg
      class="progress-circle __svg"
      :width="outerSquare"
      :height="outerSquare"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="progress-circle __inner-circle"
        :style="{ stroke: innerCircleColor, strokeWidth: `${ringWidth}px` }"
        :r="radius"
        :cx="centerPoint"
        :cy="centerPoint"
        fill="transparent"
        :stroke-dasharray="circumference"
      />
      <circle
        class="progress-circle __bar"
        :style="{
          stroke: progressBarColor,
          strokeWidth: `${ringWidth}px`,
          strokeDashoffset,
          transition: `stroke-dashoffset ${animationDuration}s cubic-bezier(0.4, 0, 0.2, 1)`,
          background: 'red'
        }"
        :r="radius"
        :cx="centerPoint"
        :cy="centerPoint"
        fill="transparent"
        :stroke-dasharray="circumference"
      />
    </svg>
    <slot />
  </div>
</template>

<script>
// inspired by https://codepen.io/JMChristensen/pen/Ablch
export default {
  props: {
    percent: {
      type: Number,
      default: 0,
    },
    innerCircleColor: {
      type: String,
      default: 'white',
    },
    progressBarColor: {
      type: String,
      default: 'blue',
    },
    radius: {
      type: Number,
      default: 90,
    },
    ringWidth: {
      type: Number,
      default: 16,
    },
    boxShadow: {
      type: String,
      default: '0 0 1em #ccc',
    },
    innerBoxShadow: {
      type: String,
      default: 'inset 0 0 1em black',
    },
    animationTriggerDelay: { // set = 0 to disable animation
      type: Number,
      default: 100,
    },
    animationDuration: { // seconds
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      strokeDashoffset: Math.PI * (this.radius * 2),
    }
  },
  computed: {
    circumference() {
      return Math.PI * (this.radius * 2)
    },
    outerSquare() {
      return this.radius * 2 + this.ringWidth
    },
    innerSquare() {
      return this.radius * 2 - this.ringWidth
    },
    centerPoint() {
      return this.radius + this.ringWidth / 2
    },
  },
  watch: {
    percent() {
      this.runAnimation()
    },
  },
  mounted() {
    this.runAnimation()
  },
  methods: {
    runAnimation() {
      setTimeout(() => {
        let pct = this.percent
        if (pct < 0 || !pct) {
          pct = 0
        } else if (pct > 100) {
          pct = 100
        }
        this.strokeDashoffset = ((100 - pct) / 100) * this.circumference
      }, this.animationTriggerDelay) // wait a bit to animation to run
    },
  },
}
</script>

<style lang="scss" scoped>
.progress-circle {
  &.__container {
    display: block;
    border-radius: 100%;
    position: relative;
  }
  &.__inner-shadow {
    position: absolute;
    display: block;
    left: 50%;
    top: 50%;
    border-radius: 100%;
  }
  &.__svg {
    transform: rotate(-90deg);
  }
}
</style>
